import { SHARED_CONST } from ":mods";

export function getAppFlavor() {
	return Promise.resolve(SHARED_CONST.BASE_APP_FLAVOR);
}
